"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Pagination.css");
var icons = require("./../../../styles/att-icons.css");
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        _this.pages = [];
        _this.firstPlay = true;
        _this.state = {
            currentPage: _this.props.data.currentPageInput ? _this.props.data.currentPageInput : 1,
            isTouch: true,
            totalPages: _this.props.data.totalPagesInput ? _this.props.data.totalPagesInput : 1,
        };
        _this.currentPageValue = _this.currentPageValue.bind(_this);
        _this.checkSelectedPage = _this.checkSelectedPage.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.next = _this.next.bind(_this);
        _this.prev = _this.prev.bind(_this);
        _this.onWindowResize = _this.onWindowResize.bind(_this);
        _this.setPaginationRef = _this.setPaginationRef.bind(_this);
        _this.checkMobile = _this.checkMobile.bind(_this);
        _this.tween = _this.tween.bind(_this);
        _this.easing = _this.easing.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        return _this;
    }
    Pagination.prototype.onWindowResize = function (ev) {
        this.checkMobile();
        this.currentPageValue(this.state.currentPage);
    };
    Pagination.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onWindowResize);
        this.handleScroll(this.paginationRef);
        window.addEventListener('scroll', this.handleScroll);
    };
    Pagination.prototype.componentWillMount = function () {
        this.checkMobile();
    };
    Pagination.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    Pagination.prototype.componentDidUpdate = function () {
        if (!this.firstPlay) {
            if (this.state.currentPage === undefined || this.state.currentPage === 1 ||
                this.state.currentPage === null || this.state.currentPage === '') {
                this.currentPageValue(1);
            }
            else {
                this.currentPageValue(this.state.currentPage);
            }
            this.handleScroll(this.paginationRef);
        }
        else {
            this.firstPlay = false;
            this.handleClick(this.state.currentPage);
        }
    };
    Pagination.prototype.componentWillReceiveProps = function (updatedProps) {
        if (updatedProps.data.totalPagesInput !== this.state.totalPages) {
            this.setState({ totalPages: updatedProps.data.totalPagesInput });
        }
    };
    Pagination.prototype.setPaginationRef = function (element) {
        this.paginationRef = element;
    };
    Pagination.prototype.handleClick = function (value) {
        var _this = this;
        this.setState({ currentPage: value }, function () {
            _this.focusedPage = value;
            if (value === undefined || value === null || value === '') {
                value = 1;
            }
            _this.currentPageValue(value);
            _this.checkSelectedPage(value);
            if (_this.props.events && _this.props.events.onClick) {
                _this.props.events.onClick(value);
            }
        });
    };
    Pagination.prototype.currentPageValue = function (value) {
        var _this = this;
        this.pages = [];
        if (!this.state.isTouch) {
            if (this.state.totalPages <= 10) {
                for (var i = 1; i <= this.state.totalPages; i++) {
                    this.pages.push(i);
                }
            }
            if (this.state.totalPages > 10) {
                if (this.state.totalPages > 99) {
                    this.state.totalPages = 99;
                }
                var val = parseInt(value, 10);
                if (val <= 6) {
                    this.pages = [1, 2, 3, 4, 5, 6, 7, 8];
                }
                else if (val > 6 && val <= this.state.totalPages - 5) {
                    this.pages = [val - 2, val - 1, val, val + 1, val + 2];
                }
                else if (val >= this.state.totalPages - 5) {
                    this.pages = [this.state.totalPages - 7, this.state.totalPages - 6, this.state.totalPages - 5,
                        this.state.totalPages - 4, this.state.totalPages - 3, this.state.totalPages - 2, this.state.totalPages - 1,
                        this.state.totalPages];
                }
            }
        }
        var w;
        var el;
        var l;
        var ew;
        if (this.state.isTouch) {
            for (var i = 1; i <= this.state.totalPages; i++) {
                this.pages.push(i);
            }
            setTimeout(function () {
                w = _this.paginationRef.getBoundingClientRect().width;
                l = _this.paginationRef.scrollLeft;
                var listElem = _this.paginationRef.querySelector('li');
                var activeElem = _this.paginationRef.querySelector('li.Pagination__active');
                if ((activeElem !== null && activeElem !== undefined) && (listElem !== null && listElem !== undefined)) {
                    ew = listElem.getBoundingClientRect().width;
                    el = activeElem.offsetLeft;
                    _this.tween(l, el - (w / 2) + (ew * 0.15), 500);
                }
            }, 200);
        }
    };
    Pagination.prototype.tween = function (start, end, duration) {
        var instance = this;
        var delta = end - start;
        var startTime;
        if (window.performance && window.performance.now) {
            startTime = performance.now();
        }
        else if (Date.now) {
            startTime = Date.now();
        }
        else {
            startTime = new Date().getTime();
        }
        var tweenLoop = function (time) {
            var t = (!time ? 0 : time - startTime);
            var factor = instance.easing(t, 0, 1, duration);
            instance.paginationRef.scrollLeft = start + delta * factor;
            if (t < duration && instance.paginationRef.scrollLeft !== end) {
                requestAnimationFrame(tweenLoop);
            }
        };
        tweenLoop(null);
    };
    Pagination.prototype.easing = function (t, b, c, d) {
        return (c * (t /= d) * t + b);
    };
    Pagination.prototype.handleScroll = function (element) {
        var w;
        var l;
        var elemWidth;
        var lastScroll;
        var totwidth;
        if (element !== undefined && element === this.paginationRef) {
            w = this.paginationRef.getBoundingClientRect().width;
            l = this.paginationRef.scrollLeft;
            var activeElem = this.paginationRef.querySelector('li.Pagination__active');
            var lastElem = this.paginationRef.querySelector('li:last-child');
            if ((activeElem !== null && activeElem !== undefined) && (lastElem !== null && lastElem !== undefined)) {
                elemWidth = activeElem.getBoundingClientRect().width / 2;
                lastScroll = lastElem.offsetLeft;
                totwidth = w + elemWidth;
                if (totwidth > lastScroll - l) {
                    this.paginationRef.parentElement.classList.remove(styles.rightblur);
                }
                if (totwidth < lastScroll - l) {
                    this.paginationRef.parentElement.classList.add(styles.rightblur);
                }
                if (l > elemWidth) {
                    this.paginationRef.parentElement.classList.add(styles.leftblur);
                }
                else {
                    this.paginationRef.parentElement.classList.remove(styles.leftblur);
                }
            }
        }
    };
    Pagination.prototype.checkSelectedPage = function (value) {
        if (this.state.currentPage === value) {
            return true;
        }
        return false;
    };
    Pagination.prototype.prev = function (event) {
        if (event !== undefined) {
            event.preventDefault();
            event.currentTarget.blur();
        }
        if (this.state.currentPage > 1) {
            this.state.currentPage -= 1;
            this.handleClick(this.state.currentPage);
        }
    };
    Pagination.prototype.next = function (event) {
        if (event !== undefined) {
            event.preventDefault();
            event.currentTarget.blur();
        }
        if (this.state.currentPage < this.state.totalPages) {
            this.state.currentPage += 1;
            this.handleClick(this.state.currentPage);
        }
    };
    Pagination.prototype.checkMobile = function () {
        if (window.innerWidth < 1025) {
            this.setState(function () { return ({ isTouch: true }); });
        }
        else {
            this.setState(function () { return ({ isTouch: false }); });
        }
    };
    Pagination.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { "data-test-id": this.props.testId },
            React.createElement("div", { className: styles.pagiSkipbtn, tabIndex: -1, role: "navigation", "aria-label": "Customer Data Pages" },
                React.createElement("div", { className: styles.paginationHolder },
                    React.createElement("div", { className: styles.pagination, ref: this.setPaginationRef },
                        (this.state.totalPages >= 1 && !this.state.isTouch) ?
                            React.createElement("ul", null,
                                (this.state.totalPages > 10) ?
                                    React.createElement("li", null,
                                        React.createElement("a", { role: "link", href: "javascript:void(0)", className: [this.state.currentPage <= 1 ?
                                                    styles.disabled : ''].join(' '), "aria-label": this.state.currentPage <= 1 ? 'Previous Page Disabled' : 'Previous Page', tabIndex: this.state.currentPage <= 1 ? -1 : 0, onClick: this.prev },
                                            React.createElement("i", { className: [icons.attIcon, icons.attIconLeft].join(' ') }))) : '',
                                (this.state.totalPages > 10 && this.state.currentPage > 6) ?
                                    React.createElement("li", null,
                                        React.createElement("a", { tabIndex: 0, href: "javascript:void(0)", onClick: this.handleClick.bind(this, 1), "aria-label": "page 1" }, "1")) : '',
                                (this.state.totalPages > 10 && this.state.currentPage > 6) ?
                                    React.createElement("li", null,
                                        React.createElement("a", { tabIndex: 0, href: "javascript:void(0)", onClick: this.handleClick.bind(this, 2), "aria-selected": this.checkSelectedPage(2), "aria-label": "page 2" }, "2")) : '',
                                (this.state.totalPages > 10 && this.state.currentPage > 6) ?
                                    React.createElement("li", { className: styles.disabled },
                                        React.createElement("span", null,
                                            "...",
                                            React.createElement("span", { tabIndex: -1, className: styles.hiddenSpoken }, "more pages"))) : '',
                                this.currentPageValue(this.state.currentPage),
                                this.pages.map(function (el) {
                                    return React.createElement("li", { value: el, key: el, className: [_this.checkSelectedPage(el) ?
                                                styles.active : ''].join(' ') },
                                        React.createElement("a", { tabIndex: 0, href: "javascript:void(0)", onClick: _this.handleClick.bind(_this, el), "aria-label": (_this.checkSelectedPage(el) ? ' Active ' : '') + 'Page ' + el }, el));
                                }),
                                (this.state.totalPages > 10 && (this.state.currentPage <= this.state.totalPages - 5) &&
                                    !this.state.isTouch) ?
                                    React.createElement("li", { className: styles.disabled },
                                        React.createElement("span", null,
                                            "...",
                                            React.createElement("span", { tabIndex: -1, className: styles.hiddenSpoken }, "more pages"))) : '',
                                (this.state.totalPages > 10 && (this.state.currentPage <= this.state.totalPages - 5)) ?
                                    React.createElement("li", null,
                                        React.createElement("a", { tabIndex: 0, href: "javascript:void(0)", onClick: this.handleClick.bind(this, this.state.totalPages - 1), "aria-selected": this.checkSelectedPage(this.state.totalPages - 1), "aria-label": 'page ' + (this.state.totalPages - 1) }, this.state.totalPages - 1)) : '',
                                (this.state.totalPages > 10 && (this.state.currentPage <= this.state.totalPages - 5)) ?
                                    React.createElement("li", null,
                                        React.createElement("a", { tabIndex: 0, href: "javascript:void(0)", onClick: this.handleClick.bind(this, this.state.totalPages), "aria-selected": this.checkSelectedPage(this.state.totalPages), "aria-label": 'page ' + (this.state.totalPages) }, this.state.totalPages)) : '',
                                (this.state.totalPages > 10) ?
                                    React.createElement("li", null,
                                        React.createElement("a", { role: "link", href: "javascript:void(0)", className: [this.state.currentPage >= this.state.totalPages ? styles.disabled : ''].join(' '), "aria-label": this.state.currentPage >= this.state.totalPages ? 'Next Page Disabled' : 'Next Page', tabIndex: this.state.currentPage >= this.state.totalPages ? -1 : 0, onClick: this.next },
                                            React.createElement("i", { className: [icons.attIcon, icons.attIconRight].join(' ') }))) : '') : '',
                        (this.state.totalPages >= 1 && this.state.isTouch) ?
                            React.createElement("ul", null,
                                this.currentPageValue(this.state.currentPage),
                                this.pages.map(function (el) {
                                    return React.createElement("li", { value: el, key: el, className: [_this.checkSelectedPage(el) ?
                                                styles.active : ''].join(' ') },
                                        React.createElement("a", { tabIndex: 0, href: "javascript:void(0)", onClick: _this.handleClick.bind(_this, el), "aria-label": (_this.checkSelectedPage(el) ? ' Active ' : '') + 'Page ' + el }, el));
                                })) : '')))));
    };
    Pagination.defaultProps = {
        options: {
            className: '',
        },
    };
    return Pagination;
}(React.Component));
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Pagination/Pagination.js
// module id = 1207
// module chunks = 8